/*
 * Copyright (C) 2018 Spanning Cloud Apps. LLC  All rights reserved.
 */
import { directive as sbsfWizard, controller as WizardCtrl } from './wizard.js';
import { directive as sbsfWizardButton, controller as WizardButtonCtrl } from './wizardButton.js';
import { factory as WizardButtonFactory } from './WizardButtonFactory.js';
import { factory as WizardPageFactory } from './WizardPageFactory.js';
import { factory as WizardService } from './WizardService.js';
import { directive as sbsfWizardSteps, controller as WizardStepsCtrl } from './wizardSteps.js';

/*
 * This module holds components used in building a wizard that takes a user through a series of steps to accomplish a
 * task.
 *
 * All the directives and controllers are defined in this one place because it seems like we can't control the order
 * in which they're defined by angular, otherwise.
 */
angular
  .module('shared.wizard', ['sbsf.constants'])
  .directive('sbsfWizard', sbsfWizard)
  .controller('WizardCtrl', WizardCtrl)
  .directive('sbsfWizardButton', sbsfWizardButton)
  .controller('WizardButtonCtrl', WizardButtonCtrl)
  .factory('WizardButtonFactory', WizardButtonFactory)
  .factory('WizardPageFactory', WizardPageFactory)
  .factory('WizardService', WizardService)
  .directive('sbsfWizardSteps', sbsfWizardSteps)
  .controller('WizardStepsCtrl', WizardStepsCtrl)
  // Define some constants we can use to notify the page what direction the user is going when they leave.
  // This can help if the confirmation message needs customizing
  .constant(
    'WizardDirection',
    Object.freeze({
      FORWARD: 'FORWARD',
      REVERSE: 'REVERSE'
    })
  );
